var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\u0421\u043B\u043E\u0439_1",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m90.13 0h-52.26a9.88 9.88 0 0 0 -9.87 9.87v108.26a9.88 9.88 0 0 0 9.87 9.87h52.26a9.88 9.88 0 0 0 9.87-9.87v-108.26a9.88 9.88 0 0 0 -9.87-9.87zm-42.13 4h32v3a1.94 1.94 0 0 1 -2 2h-28a1.94 1.94 0 0 1 -2-2zm48 114.13a5.89 5.89 0 0 1 -5.87 5.87h-52.26a5.89 5.89 0 0 1 -5.87-5.87v-108.26a5.89 5.89 0 0 1 5.87-5.87h6.13v3a5.94 5.94 0 0 0 6 6h28a5.94 5.94 0 0 0 6-6v-3h6.13a5.89 5.89 0 0 1 5.87 5.87z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m64 34a8 8 0 1 0 8 8 8 8 0 0 0 -8-8zm0 12a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m44 34a8 8 0 1 0 8 8 8 8 0 0 0 -8-8zm0 12a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m84 34a8 8 0 1 0 8 8 8 8 0 0 0 -8-8zm0 12a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m64 54a8 8 0 1 0 8 8 8 8 0 0 0 -8-8zm0 12a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m44 54a8 8 0 1 0 8 8 8 8 0 0 0 -8-8zm0 12a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m84 54a8 8 0 1 0 8 8 8 8 0 0 0 -8-8zm0 12a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m64 74a8 8 0 1 0 8 8 8 8 0 0 0 -8-8zm0 12a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m44 74a8 8 0 1 0 8 8 8 8 0 0 0 -8-8zm0 12a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m84 74a8 8 0 1 0 8 8 8 8 0 0 0 -8-8zm0 12a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m64 94a8 8 0 1 0 8 8 8 8 0 0 0 -8-8zm0 12a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.dd1f2420c391e70a76ffbd05caf4d560.svg";
export { ForwardRef as ReactComponent };